"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIfDateIsSameOrAfterComparedDate = exports.lastDayOfNextNMonths = exports.compareTimestampsStrict = exports.compareTimestamps = exports.convertToLegacyTimestamp = exports.getYearsDifference = exports.getMonthsDifference = exports.datesDifference = exports.getMostRecentDate = exports.checkIfDateIsAfterComparedDate = exports.getDurationInMinutes = exports.getCurrentYear = exports.addSecondsToTimestamp = exports.getEndTimeFromDate = exports.getStartTimeFromDate = exports.getCurrentTimestampAddMinutes = exports.getCurrentTimestampMinusMinutes = exports.getCurrentTimestampDate10Decimal6 = exports.getCurrentQuarter = exports.getFutureDate = exports.getEarlierDate = exports.getPreviousMonthAndYear = exports.getCurrentMonthAndYear = exports.getCurrentDate = exports.convertYearAndMonthCountToYYMMformat = exports.convertUtcTimestampToDate = exports.convertTimestampToDate = exports.convertDateToTimestamp = exports.convertToTimestamp = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var COLON_TIMESTAMP_REGEX = /:/g; // replaces all ':'
var DATE_FORMAT = 'YYYY-MM-DD';
var convertLegacyDateDelimeter = function (timestamp) {
    return "".concat(timestamp.substring(0, DATE_FORMAT.length), " ").concat(timestamp.substring(DATE_FORMAT.length + 1));
};
var convertToTimestamp = function (timestamp) {
    return (0, moment_timezone_1.default)(timestamp).format('YYYY-MM-DD HH:mm:ss.SSSSSS');
};
exports.convertToTimestamp = convertToTimestamp;
var convertDateToTimestamp = function (date, inputFormat) {
    return (0, moment_timezone_1.default)(date, inputFormat).format('YYYY-MM-DD HH:mm:ss.SSSSSS');
};
exports.convertDateToTimestamp = convertDateToTimestamp;
var convertTimestampToDate = function (timestamp) {
    return timestamp != null ? (0, moment_timezone_1.default)(timestamp).format('YYYY-MM-DD') : timestamp;
};
exports.convertTimestampToDate = convertTimestampToDate;
var convertUtcTimestampToDate = function (timestamp) {
    return timestamp != null ? moment_timezone_1.default.utc(timestamp).format('YYYY-MM-DD') : timestamp;
};
exports.convertUtcTimestampToDate = convertUtcTimestampToDate;
var convertYearAndMonthCountToYYMMformat = function (year, month) {
    var yearStr = "".concat(year);
    var monthStr = month != null ? "".concat(month) : '00';
    if (yearStr.length < 2) {
        yearStr = "0".concat(yearStr);
    }
    if (monthStr.length < 2) {
        monthStr = "0".concat(monthStr);
    }
    return "".concat(yearStr).concat(monthStr);
};
exports.convertYearAndMonthCountToYYMMformat = convertYearAndMonthCountToYYMMformat;
var getCurrentDate = function () {
    return (0, moment_timezone_1.default)().tz('America/Toronto').format('YYYY-MM-DD');
};
exports.getCurrentDate = getCurrentDate;
var getCurrentMonthAndYear = function () {
    return (0, moment_timezone_1.default)().tz('America/Toronto').format('YYYY-MM');
};
exports.getCurrentMonthAndYear = getCurrentMonthAndYear;
var getPreviousMonthAndYear = function () {
    return (0, moment_timezone_1.default)().subtract(1, 'months').tz('America/Toronto').format('YYYY-MM');
};
exports.getPreviousMonthAndYear = getPreviousMonthAndYear;
var getEarlierDate = function (date) {
    return (0, moment_timezone_1.default)(date).subtract(2, 'days').format('YYYY-MM-DD');
};
exports.getEarlierDate = getEarlierDate;
var getFutureDate = function (date) {
    return (0, moment_timezone_1.default)(date).add(1, 'days').format('YYYY-MM-DD');
};
exports.getFutureDate = getFutureDate;
var getCurrentQuarter = function (date) {
    var quarter = (0, moment_timezone_1.default)(date).quarter().toString();
    return "Q".concat(quarter);
};
exports.getCurrentQuarter = getCurrentQuarter;
var getCurrentTimestampDate10Decimal6 = function () {
    return (0, moment_timezone_1.default)().tz('America/Toronto').format('YYYY-MM-DD HH:mm:ss.SSSSSS');
};
exports.getCurrentTimestampDate10Decimal6 = getCurrentTimestampDate10Decimal6;
var getCurrentTimestampMinusMinutes = function (minutes) {
    return (0, moment_timezone_1.default)()
        .tz('America/Toronto')
        .subtract(minutes, 'minutes')
        .format('YYYY-MM-DD HH:mm:ss.SSSSSS');
};
exports.getCurrentTimestampMinusMinutes = getCurrentTimestampMinusMinutes;
var getCurrentTimestampAddMinutes = function (minutes) {
    return (0, moment_timezone_1.default)()
        .tz('America/Toronto')
        .add(minutes, 'minutes')
        .format('YYYY-MM-DD HH:mm:ss.SSSSSS');
};
exports.getCurrentTimestampAddMinutes = getCurrentTimestampAddMinutes;
var getStartTimeFromDate = function (dateToConvert) {
    var startOfTheDay = (0, moment_timezone_1.default)(dateToConvert);
    return startOfTheDay.startOf('day').format('YYYY-MM-DD HH:mm:ss.SSSSSS');
};
exports.getStartTimeFromDate = getStartTimeFromDate;
var getEndTimeFromDate = function (dateToConvert) {
    var endOfTheDay = (0, moment_timezone_1.default)(dateToConvert);
    return endOfTheDay.endOf('day').format('YYYY-MM-DD HH:mm:ss.SSSSSS');
};
exports.getEndTimeFromDate = getEndTimeFromDate;
var addSecondsToTimestamp = function (timestamp, seconds) {
    return (0, moment_timezone_1.default)(timestamp).add(seconds, 'seconds').format('YYYY-MM-DD HH:mm:ss.SSSSSS');
};
exports.addSecondsToTimestamp = addSecondsToTimestamp;
var getCurrentYear = function (date) {
    return (0, moment_timezone_1.default)(date).format('YYYY');
};
exports.getCurrentYear = getCurrentYear;
var getDurationInMinutes = function (createTime, updateTime) {
    var createMoment = (0, moment_timezone_1.default)(createTime);
    var updateMoment = (0, moment_timezone_1.default)(updateTime);
    return Math.abs(moment_timezone_1.default.duration(createMoment.diff(updateMoment)).asMinutes());
};
exports.getDurationInMinutes = getDurationInMinutes;
var checkIfDateIsAfterComparedDate = function (beforeDate, comparedDate) {
    if (beforeDate == null) {
        return false;
    }
    if (comparedDate == null) {
        return true;
    }
    return (0, moment_timezone_1.default)(beforeDate).isAfter(comparedDate);
};
exports.checkIfDateIsAfterComparedDate = checkIfDateIsAfterComparedDate;
var getMostRecentDate = function (dates) {
    return dates.reduce(function (firstDate, secondDate) {
        return (0, exports.checkIfDateIsAfterComparedDate)(firstDate, secondDate) ? firstDate : secondDate;
    });
};
exports.getMostRecentDate = getMostRecentDate;
var datesDifference = function (date1, date2) {
    return (0, moment_timezone_1.default)(date2).diff((0, moment_timezone_1.default)(date1));
};
exports.datesDifference = datesDifference;
var getMonthsDifference = function (firstDate, secondDate) {
    return (0, moment_timezone_1.default)(secondDate).diff((0, moment_timezone_1.default)(firstDate), 'months', true);
};
exports.getMonthsDifference = getMonthsDifference;
var getYearsDifference = function (firstDate, secondDate) {
    return (0, moment_timezone_1.default)(secondDate).diff((0, moment_timezone_1.default)(firstDate), 'years', true);
};
exports.getYearsDifference = getYearsDifference;
var convertToLegacyTimestamp = function (timestamp) {
    if (timestamp == null) {
        throw new Error('Error converting null/undefined timestamp to legacy format');
    }
    return convertLegacyDateDelimeter(timestamp).replace(COLON_TIMESTAMP_REGEX, '.');
};
exports.convertToLegacyTimestamp = convertToLegacyTimestamp;
var compareTimestamps = function (firstTimestamp, secondTimestamp) {
    if (firstTimestamp == null || secondTimestamp == null) {
        return false;
    }
    return (0, exports.convertToLegacyTimestamp)(firstTimestamp) >= (0, exports.convertToLegacyTimestamp)(secondTimestamp);
};
exports.compareTimestamps = compareTimestamps;
var compareTimestampsStrict = function (firstTimestamp, secondTimestamp) {
    if (firstTimestamp == null || secondTimestamp == null) {
        return false;
    }
    return (0, exports.convertToLegacyTimestamp)(firstTimestamp) > (0, exports.convertToLegacyTimestamp)(secondTimestamp);
};
exports.compareTimestampsStrict = compareTimestampsStrict;
var lastDayOfNextNMonths = function (date, n) {
    return (0, moment_timezone_1.default)(date).add(n, 'months').endOf('month').format('YYYY-MM-DD');
};
exports.lastDayOfNextNMonths = lastDayOfNextNMonths;
var checkIfDateIsSameOrAfterComparedDate = function (beforeDate, comparedDate) {
    if (beforeDate == null) {
        return false;
    }
    if (comparedDate == null) {
        return true;
    }
    return (0, moment_timezone_1.default)(beforeDate).isSameOrAfter(comparedDate);
};
exports.checkIfDateIsSameOrAfterComparedDate = checkIfDateIsSameOrAfterComparedDate;
